<template>
  <div :class="[row ? 'flex items-center flex-wrap gap-4' : '']">
    <label
      v-if="!noLabel"
      :for="name"
      class="cursor-pointer flex items-center gap-2 text-sm font-medium dark:text-gray-300 text-primary"
      :class="[row ? '' : 'mb-2', { 'pl-4': !reverse }]"
    >
      {{ $t(label || "")
      }}<span v-if="required" class="text-danger dark:text-danger"> *</span>
      <tippy v-if="tooltip" class="flex items-center justify-center">
        <BaseIcon name="info" class="text-success hover:ring-success" />
        <template #content>
          <slot name="tooltip">{{ tooltip }}</slot>
        </template>
      </tippy>
    </label>
    <div
      class="pl-1 md:pl-0"
      :class="[
        { 'order-first': reverse },
        rowRadio
          ? 'flex items-center gap-3'
          : size
            ? 'grid grid-cols-1 gap-4'
            : ' grid grid-cols-1 gap-1',
      ]"
    >
      <BaseRadio
        v-for="item in list"
        :key="item.name"
        type="radio"
        :type-view="type"
        :id="item.id"
        :name="item.name"
        :value="item.value"
        :size="size"
        :label="item.label"
        :modelValue="modelValue"
        :disabled="disabled || item.disabled"
        @update:modelValue="$emit('update:modelValue', $event)"
      />
    </div>

    <div :class="[' pl-4 mb-2', { 'h-5': !denseError }]">
      <ErrorMessage
        :name="name"
        v-slot="{ message }"
        class="text-danger dark:text-danger text-sm"
        as="span"
      >
        {{ $t(message || "") }}
      </ErrorMessage>
    </div>
  </div>
</template>

<script>
import { toRef, computed } from "vue";
import { ErrorMessage } from "vee-validate";
import BaseRadio from "./BaseRadio.vue";

export default {
  components: { BaseRadio, ErrorMessage },
  props: {
    label: String,
    name: String,
    type: {
      type: String,
      default: "radio",
    },
    id: String,
    placeholder: String,
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
    modelValue: {
      type: [Boolean, String, Number],
      default: true,
    },
    row: {
      type: Boolean,
      default: false,
    },
    rowRadio: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    btn: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Object,
      default: () => [],
    },
    check: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    denseError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    // use `toRef` to create reactive references to `name` prop which is passed to `useField`
    // this is important because vee-validte needs to know if the field name changes
    // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
    // const name = toRef(props, "name");
    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    // console.log('name :>> ', name.value);
    // const {
    //     value: inputValue,
    //     errorMessage,
    //     handleBlur,
    //     handleChange,
    //     meta,
    //     checked,
    // } = useField(toRef(props, "name"), undefined, {
    //     initialValue: computed(() => props.modelValue),
    //     type: toRef(props, "type"),
    //     checkedValue: toRef(props, "value"),
    // });
    // const onChange = ({ target }) => {
    //     handleChange(props.value);
    //     emit("update:modelValue", inputValue.value);
    // };
    // return {
    //     handleChange,
    //     handleBlur,
    //     errorMessage,
    //     inputValue,
    //     meta,
    //     onChange,
    //     checked,
    // };
  },
};
</script>

<style scoped></style>
